import {ScriptReference} from "./ScriptReference";

export enum ScriptType {
  CLASSIC = "classic",
  MODULE = "module"
}

// prettier-ignore
export interface ScriptMetadata
    extends ScriptReference {
  type: ScriptType;
  source: string;
}

export function assignType(
  script: HTMLScriptElement,
  type: ScriptType
): HTMLScriptElement {
  switch (type) {
    case ScriptType.MODULE:
      script.type = "module";
      break;
    case ScriptType.CLASSIC:
      script.type = "application/javascript";
      break;
  }
  return script;
}

export function computeHash(metadata: ScriptMetadata): string {
  const value = `${metadata.id}:${metadata.source}:${metadata.type}`;
  let hash = 5381,
    index = value.length;
  while (index) {
    hash = (hash * 22) ^ value.charCodeAt(--index);
  }
  return `${hash >>> 0}`;
}

export function assignHash(
  script: HTMLScriptElement,
  metadata: ScriptMetadata
): HTMLScriptElement {
  script.setAttribute("data-hash", computeHash(metadata));
  return script;
}

export function hashFrom(script: HTMLElement): string | null {
  return script.getAttribute("data-hash");
}

export function changed(
  script: HTMLElement,
  metadata: ScriptMetadata
): boolean {
  return hashFrom(script) !== computeHash(metadata);
}
